import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import React, { useMemo, useState } from "react";
import { getAxiosImportServer } from "../../shared/Services/importService";
import { IMPORT_SPORT } from "../../utils/api/ApiConstant";
import { DataTable, Filter, SubHeading, Switch } from "../../shared/Components";
import { postAxios } from "../../shared/Services/commonService";
import showToast from "../../utils/toastUtil";
import DateUtils from "../../utils/dateUtils";
import { createImportColumn } from "../../utils/importColumn";

let savedEvent = 1;
const Import = () => {
  const navigate = useNavigate();
  const [selectedItems, setSelectedItems] = useState({});
  const [filterParams, setFilterParams] = useState({ event: savedEvent });

  const handleFilterParams = (values) => {
    const event = values?.event?.value || null;
    savedEvent = event;
    setFilterParams({ event });
    setSelectedItems({});
  };

  const { isLoading, data, refetch } = useQuery({
    queryKey: ["importSportData", filterParams],
    queryFn: async () =>
      await getAxiosImportServer(`${IMPORT_SPORT}/${filterParams.event}`, {}),
  });

  const handleSwitchToggle = (id) => {
    setSelectedItems((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const handleImport = async () => {
    const selectedIds = Object.keys(selectedItems)
      .filter((id) => selectedItems[id])
      .map((id) => String(id));

    if (selectedIds.length === 0) {
      showToast.info("Please select at least one item to import");
      return;
    }

    try {
      const response = await postAxios(
        `${IMPORT_SPORT}/${filterParams.event}`,
        {
          eventType_ids: selectedIds,
        },
      );

      setSelectedItems({});
      refetch();
    } catch (error) {
      console.error("Import failed", error);
    }
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "Name",
        header: "Name",
        cell: ({ getValue, row }) => {
          return (
            <span
              onClick={() =>
                navigate(
                  `/config/import2/${filterParams.event}/${row.original.Id}/${row.original.Name}`,
                  {
                    state: {
                      sport: row?.original,
                      source: filterParams.event,
                    },
                  },
                )
              }
              className="cursor-pointer btn btn_default"
            >
              {getValue()}
            </span>
          );
        },
      },
      {
        accessorKey: "actionOn",
        header: "Action Date",
        cell: ({ getValue }) => DateUtils.fromUTC(getValue()),
      },
      createImportColumn({
        data,
        selectedItems,
        setSelectedItems,
        handleSwitchToggle,
      }),
    ],
    [data, selectedItems],
  );

  return (
    <>
      <SubHeading
        appendBreadcrumbs={[{ label: "Sport" }]}
        isAddBtnPage={false}
        isAddBtn={false}
        isImport={true}
        onClick={handleImport}
      />
      <Filter
        isEvent={true}
        handleFilterParams={handleFilterParams}
        selectedSource={filterParams.event}
      />
      <div className="card-body">
        <DataTable
          columns={columns}
          data={data?.data}
          isSearchable={true}
          isPagination={true}
          isPageSize={true}
          isLoading={isLoading}
        />
      </div>
    </>
  );
};

export default Import;
